export const homeSliders_DVUT = [
    {
        imgUrl: 'https://res.cloudinary.com/dp5xqgbsj/image/upload/v1747087854/480913452_632037896142198_3988481439064926306_n_b6m0ft.jpg',
        title: 'Đoàn viên ưu tú 2021 - 2022',
        content:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    },
]

export const DVUT_2024_2025 = [
    {
        imgUrl: 'https://res.cloudinary.com/dp5xqgbsj/image/upload/v1747087851/480609550_632037569475564_8708422969664936273_n_ctt615.jpg',
        title: 'Đoàn viên ưu tú 2024-2025',
        content:
            '✍️Sinh viên 5 Tốt là danh hiệu cao quý của sinh viên Việt Nam đã được đưa vào hệ thống khen thưởng cấp Quốc gia và ngày càng trở thành danh hiệu có uy tín, là minh chứng cho sự cố gắng, nỗ lực không chỉ của mỗi cá nhân sinh viên mà còn là sự phấn đấu của tập thể Liên Chi hội...',
    },
    {
        imgUrl: 'https://res.cloudinary.com/dp5xqgbsj/image/upload/v1747087802/495371990_693337376678916_7232354277833243234_n_xzpu3z.jpg',
        title: 'Đoàn viên ưu tú 2024-2025',
        content:
            '✍️Sinh viên 5 Tốt là danh hiệu cao quý của sinh viên Việt Nam đã được đưa vào hệ thống khen thưởng cấp Quốc gia và ngày càng trở thành danh hiệu có uy tín, là minh chứng cho sự cố gắng, nỗ lực không chỉ của mỗi cá nhân sinh viên mà còn là sự phấn đấu của tập thể Liên Chi hội...',
    },
    {
        imgUrl: 'https://res.cloudinary.com/dp5xqgbsj/image/upload/v1747087851/480609550_632037569475564_8708422969664936273_n_ctt615.jpg',
        title: 'Đoàn viên ưu tú 2024-2025',
        content:
            '✍️Sinh viên 5 Tốt là danh hiệu cao quý của sinh viên Việt Nam đã được đưa vào hệ thống khen thưởng cấp Quốc gia và ngày càng trở thành danh hiệu có uy tín, là minh chứng cho sự cố gắng, nỗ lực không chỉ của mỗi cá nhân sinh viên mà còn là sự phấn đấu của tập thể Liên Chi hội...',
    },
    {
        imgUrl: 'https://res.cloudinary.com/dp5xqgbsj/image/upload/v1747086982/%E1%BA%A2nh_ch%E1%BB%A5p_m%C3%A0n_h%C3%ACnh_2025-05-13_045557_qgcwdt.png',
        title: 'Đoàn viên ưu tú 2024-2025',
        content:
            '✍️Sinh viên 5 Tốt là danh hiệu cao quý của sinh viên Việt Nam đã được đưa vào hệ thống khen thưởng cấp Quốc gia và ngày càng trở thành danh hiệu có uy tín, là minh chứng cho sự cố gắng, nỗ lực không chỉ của mỗi cá nhân sinh viên mà còn là sự phấn đấu của tập thể Liên Chi hội...',
    },
    {
        imgUrl: 'https://res.cloudinary.com/dp5xqgbsj/image/upload/v1747087857/485147273_655046577174663_2362015672013807113_n_uqniwd.jpg',
        title: 'Đoàn viên ưu tú 2024-2025',
        content:
            '✍️Sinh viên 5 Tốt là danh hiệu cao quý của sinh viên Việt Nam đã được đưa vào hệ thống khen thưởng cấp Quốc gia và ngày càng trở thành danh hiệu có uy tín, là minh chứng cho sự cố gắng, nỗ lực không chỉ của mỗi cá nhân sinh viên mà còn là sự phấn đấu của tập thể Liên Chi hội...',
    },
]
